<template>
  <div id="guild-app">
    <login-view v-if="!account" @logged-in="handleLoggedIn" />
    <guild-shell v-else :account="account" @logout="handleLogout" />
  </div>
</template>

<script>
import { logout, profileGet } from "./api/guild"
import { clearGuildToken, getGuildToken } from "./api/request"
import GuildShell from "./components/GuildShell.vue"
import LoginView from "./components/LoginView.vue"

export default {
  name: "App",
  components: { GuildShell, LoginView },
  data: () => ({ account: null }),
  created() {
    window.addEventListener("guild-auth-required", this.handleAuthRequired)
    if (getGuildToken()) this.loadProfile()
  },
  beforeDestroy() {
    window.removeEventListener("guild-auth-required", this.handleAuthRequired)
  },
  methods: {
    async loadProfile() {
      try {
        const res = await profileGet()
        this.account = res.data
      } catch (error) {
        clearGuildToken()
      }
    },
    handleLoggedIn(account) { this.account = account },
    handleAuthRequired() { this.account = null },
    async handleLogout() {
      try { await logout() } catch (error) { /* 本地会话仍需清理。 */ }
      clearGuildToken()
      this.account = null
    }
  }
}
</script>
